const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSupplyChainPlaceholderImage = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.27216,0,0,1.27216,-20.5232,-19.4654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.257,24.766C49.292,24.32 49.661,24.023 50.108,24.023L97.512,24.023C97.954,24.023 98.319,24.305 98.36,24.745C99.157,33.329 106.602,115.607 99.869,122.379C99.799,122.45 99.734,122.485 99.64,122.521C90.969,125.781 55.702,126.628 48.152,122.578C48.016,122.505 47.931,122.424 47.862,122.286C42.662,111.823 48.598,33.258 49.257,24.766Z",
    style: {
      fill: "rgb(244,245,250)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.836,65.365C56.835,65.127 57.027,64.933 57.265,64.933L101.354,64.933C101.354,64.933 103.536,93.515 102.712,103.51L57.512,103.839C57.275,103.841 57.081,103.65 57.08,103.413L56.836,65.365Z",
    style: {
      fill: "rgb(93,109,152)",
      fillOpacity: 0.3,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.644,38.423C71.644,38.237 71.493,38.085 71.307,38.085L51.996,38.085C51.81,38.085 51.659,38.237 51.659,38.423L51.659,41.696C51.659,41.882 51.81,42.033 51.996,42.033L71.307,42.033C71.493,42.033 71.644,41.882 71.644,41.696L71.644,38.423Z",
    style: {
      fill: "rgb(93,109,152)",
      fillOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.306,45.332C78.306,45.146 78.155,44.995 77.969,44.995L51.996,44.995C51.81,44.995 51.659,45.146 51.659,45.332L51.659,47.618C51.659,47.805 51.81,47.956 51.996,47.956L77.969,47.956C78.155,47.956 78.306,47.805 78.306,47.618L78.306,45.332Z",
    style: {
      fill: "rgb(93,109,152)",
      fillOpacity: 0.3
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSupplyChainPlaceholderImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/supply-chain-placeholder-image.50587072973ee849859fba3c477f9034.svg";